import React from 'react';
import { FieldRenderProps } from 'react-final-form';

import { DatePicker, DatePickerOptionalProps, DatePickerValueType } from './DatePicker';

export const DatePickerField = (props: DatePickerOptionalProps) => ({
  input,
  meta,
}: FieldRenderProps<DatePickerValueType>) => <DatePicker inputId={input.name} {...props} input={input} meta={meta} />;
